import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// Componentes
import VistaEducativos from "../vistas/VistaEducativos";
import FormEducativos from "../formularios/FormEducativos";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
import { AlertBoxContext } from "../../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Utils
import { tiposEducacionObra } from "../../../../contexto";
// Custom spinner
import CustomSpinner from "../../../generic/CustomSpinner";

const Educativos = ({ idProvincia, idMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos educativos de la misión
  const [datosEducativos, setDatosEducativos] = useState({});
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosEducativos();
  }, []);

  // Obtiene los datos educativos de la obra
  const getDatosEducativos = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/estudiantes`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de una misión de tipo educativa
  const postDatosEducativos = (data) => {
    console.log(data)
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/estudiantes`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de la misión de categoria educativa
  const handleGetDatosEducativos = () => {
    setLoading(true);
    getDatosEducativos()
      .then((response) => {
        setLoading(false);
        setDatosEducativos(processDatosEducativos(response.items));
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos educativos de una mision
  const handlePostDatosEducativos = (data) => {
    setLoading(true);
    modalSetShow(false);

    Promise.all(
      Object.keys(tiposEducacionObra).map((tipoEducativo) => {
        return postDatosEducativos(data[tipoEducativo]);
      })
    )
      .then((response) => {
        setLoading(false);
        setDatosEducativos(processDatosEducativos(response));
        addAlert("Exito", "Se ha editado la estructura de la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejamos con la siguiente función los datos educativos para poder pintarlos para ello los guardamos en el estado
  const processDatosEducativos = (misDatosEducativos) => {
    let returnDatosEducativos = {};
    // Recorremos y rellenamos con los que devuelve la petición
    for (let tipoDatoEducativo of misDatosEducativos) {
      returnDatosEducativos[tipoDatoEducativo.type] = tipoDatoEducativo;
    }
    return returnDatosEducativos;
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Estructura de la obra
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Editar estructura de la obra");
                modalSetContent(<FormEducativos defaultValues={datosEducativos} submissionHandler={handlePostDatosEducativos} />);
              }}
            >
              Editar
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className={"bg-light"}>
              <VistaEducativos datosEducativos={datosEducativos} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Educativos;
